// Module
var code = "<md-button class=\"color-item\" ng-click=\"ctrl.select(item)\" ng-repeat=\"item in ctrl.colors\" aria-label=\"color {{item.name}}\"> <div class=\"contents\"> <div class=\"circle\" ng-style=\"ctrl.style(item)\"></div> </div> </md-button> ";
// Exports
module.exports = code;